import type { AuthcOptions } from './authc'
import { Authc } from './authc'

export * from '../wallet'
export * from './authc'
export * from '../'

/**
 * Asynchronously creates the AuthcClient instance and calls `checkSession`.
 *
 * **Note:** There are caveats to using this in a private browser tab, which may not silently authenticae
 * a user on page refresh. Please see [the checkSession docs](https://authc.github.io/authc-spa-js/classes/authcclient.html#checksession) for more info.
 *
 * @param options The client options
 * @returns An instance of AuthcClient
 */
export default function createAuthc(options: AuthcOptions) {
  const authc = new Authc(options)
  authc.checkSession().catch((err) => {
    authc.logout({
      localOnly: true,
    })
  })
  return authc
}
